export const STS_AUTHORITY =
  "https://prijava.eid.gov.rs/oauth2/oidcdiscovery/";
export const CLIENT_ID = "fMMeRZxGbHW9p5cq3g2RgEHhP8sa";
export const CLIENT_ROOT = "https://ekonsultacije.gov.rs/";
export const CLIENT_SCOPE = "openid profile name id gender residence mail";
